import { createAction, props } from '@ngrx/store';
import { Printlogs } from './printlogs.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records printlogs'
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records printlogs success', 
    props<{ listData: Printlogs[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records printlogs failure', 
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state printlogs',
);